// DEPRECATED COMPONENT, DO NOT USE. USE APP-COMPONENTS EmailAddress INSTEAD.
import React from 'react';
import PropTypes from 'prop-types';
import { truncate } from 'lodash';
import classnames from 'classnames';

/**
 * @visibleName EmailAddress DEPRECATED
*/

var EmailAddress = function EmailAddress(_ref) {
  var className = _ref.className,
    disableLink = _ref.disableLink,
    emailAddress = _ref.emailAddress;
  var email = emailAddress.email_address ? emailAddress.email_address : emailAddress;
  return /*#__PURE__*/React.createElement("span", {
    className: classnames('ui-email-address', className)
  }, disableLink ? email : /*#__PURE__*/React.createElement("a", {
    href: "mailto:".concat(email),
    title: email
  }, truncate(email, {
    length: 40
  })));
};
EmailAddress.propTypes = {
  /** className */
  className: PropTypes.string,
  /** true to disable the mailto link */
  disableLink: PropTypes.bool,
  /** email address string or object */
  emailAddress: PropTypes.oneOfType([PropTypes.object, PropTypes.string]).isRequired
};
EmailAddress.defaultProps = {
  className: '',
  disableLink: false
};
export default EmailAddress;